import alerts from 'Core/ducks/alerts';
import legalAcceptance from 'Core/ducks/legalAcceptance';
import legalDocument from 'Core/ducks/legalDocument';
import modal from 'Core/ducks/modal';
import search from 'Core/ducks/search';
import snackbar from 'Core/ducks/snackbar';
import breadcrumbs from 'Core/ducks/breadcrumbs';

export default {
  snackbar,
  breadcrumbs,
  alerts,
  modal,
  legalAcceptance,
  search,
  legalDocument,
};
